export default "__VITE_ASSET__CMzupg9D__"